import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-modal-window-button-selection',
  templateUrl: './modal-window-button-selection.component.html',
  styleUrls: ['./modal-window-button-selection.component.scss']
})
export class ModalWindowButtonSelectionComponent implements OnInit {

  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();

  constructor(
  ) { }

  ngOnInit() {
  }
  onCancelClick() {
    this.modalWindowResponse.next({confirmed: false});
  }
  onButtonClick(name) {
    this.modalWindowResponse.next({confirmed: true, selectionResult: name});
  }
}
